if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".product-form__submit-loading").style.display =
          "block";
        this.querySelector(".product-form__submit-arrow").style.display =
          "none";

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);
        const id = this.form.querySelector('[name="id"]').value;
        formData.append("id", id);
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`/cart/add`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            document.querySelector("cart-open").openCart();
            [
              { id: "main-cart-items", selector: ".cart__items" },
              { id: "main-cart-footer", selector: ".cart__footer-inner" },
              { id: "main-cart-header", selector: "#main-cart-header" },
              { id: "cart-icon-bubble", selector: "#cart-icon-bubble" },
            ].forEach((group) => {
              fetch(`?section_id=${group.id}`)
                .then((resp) => resp.text())
                .then((state) => {
                  document.querySelector(group.selector).innerHTML = state;
                });
            });
            const cartFooter = document.getElementById("main-cart-footer");

            if (cartFooter) cartFooter.classList.remove("is-empty");
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".product-form__submit-loading").style.display =
              "none";
            this.querySelector(".product-form__submit-arrow").style.display =
              "block";
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }

        setTimeout(() => {
          this.errorMessageWrapper.toggleAttribute("hidden", true);
        }, 5000);
      }
    }
  );
}
